"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _localization = _interopRequireDefault(require("../../localization"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = {
  version: '0.0.1',
  schema: '0.0.1',
  locale: 'en-US',
  configuration: {
    client: {},
    boilerplate: _localization.default
  }
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/config/application-context/application-localization.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ2ZXJzaW9uIiwic2NoZW1hIiwibG9jYWxlIiwiY29uZmlndXJhdGlvbiIsImNsaWVudCIsImJvaWxlcnBsYXRlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbmZpZy9hcHBsaWNhdGlvbi1jb250ZXh0L2FwcGxpY2F0aW9uLWxvY2FsaXphdGlvbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgYm9pbGVycGxhdGUgZnJvbSAnLi4vLi4vbG9jYWxpemF0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQge1xuXHR2ZXJzaW9uOiAnMC4wLjEnLFxuXHRzY2hlbWE6ICcwLjAuMScsXG5cdGxvY2FsZTogJ2VuLVVTJyxcblx0Y29uZmlndXJhdGlvbjoge1xuXHRcdGNsaWVudDoge30sXG5cdFx0Ym9pbGVycGxhdGUsXG5cdH0sXG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFBNkM7RUFBQTtFQUFBO0FBQUE7QUFBQTtFQUFBO0FBQUE7QUFBQSxlQUU5QjtFQUNkQSxPQUFPLEVBQUUsT0FBTztFQUNoQkMsTUFBTSxFQUFFLE9BQU87RUFDZkMsTUFBTSxFQUFFLE9BQU87RUFDZkMsYUFBYSxFQUFFO0lBQ2RDLE1BQU0sRUFBRSxDQUFDLENBQUM7SUFDVkMsV0FBVyxFQUFYQTtFQUNEO0FBQ0QsQ0FBQztBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9